import { createEvent } from 'effector';
import type { TenantBranding } from '@buildex/module-contract';

/**
 * Real-time превью брендинга из админки (§8):
 * админка рендерит кабинет в iframe (?previewMode=1) и шлёт postMessage
 * с TenantBranding. Ничего не сохраняется до PUT из админки.
 */

export const BRANDING_PREVIEW_MESSAGE = 'BRANDING_PREVIEW';

export const brandingPreviewReceived = createEvent<TenantBranding>();

interface BrandingPreviewMessage {
  type: typeof BRANDING_PREVIEW_MESSAGE;
  payload: TenantBranding;
}

function isBrandingPreviewMessage(data: unknown): data is BrandingPreviewMessage {
  if (typeof data !== 'object' || data === null) return false;
  const msg = data as Record<string, unknown>;
  if (msg.type !== BRANDING_PREVIEW_MESSAGE) return false;
  const payload = msg.payload as Record<string, unknown> | undefined;
  return typeof payload === 'object' && payload !== null && typeof payload.primaryColor === 'string';
}

export function isPreviewMode(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('previewMode');
}

/**
 * Подписка на postMessage. Валидация origin обязательна (§8).
 * Возвращает функцию отписки.
 */
export function initBrandingPreview(allowedOrigins: readonly string[]): () => void {
  const listener = (event: MessageEvent<unknown>) => {
    if (!allowedOrigins.includes(event.origin)) return;
    if (isBrandingPreviewMessage(event.data)) {
      brandingPreviewReceived(event.data.payload);
    }
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}
